import React, { FC }            from "react";
import { useDispatch }          from "react-redux";
import { Button, Icon }         from "semantic-ui-react";
import CustomerRecord           from "../../../../domain/record/customer/CustomerRecord";
import CustomerRecordRepository from "../../../../domain/record/customer/CustomerRecordRepository";
import CustomerRecordDataSource from "../../../../infrastructure/datasource/record/customer/CustomerRecordDataSource";
import RouterDispatcher         from "../../../../infrastructure/redux/router/RouterDispatcher";

interface Props {
  customerRecord: CustomerRecord;
}

const CustomerRecordEditButton: FC<Props> = (props: Props) => {
  const {customerRecord} = props;
  const repository: CustomerRecordRepository = new CustomerRecordDataSource(useDispatch());
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => {
          repository.setCustomerRecord(customerRecord);
          routerDispatcher.customerRecordEdit();
        } }
      >
        <Icon name="edit"/>
        編集する
      </Button>
    </>
  );
};

export default CustomerRecordEditButton;
